import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TabPanel, TabView } from 'primereact/tabview'
import ConfirmDialog from '../../components/ui/ConfirmDialog'
import PageHeader from '../../components/ui/PageHeader'
import FlightRecordsTab from './components/FlightRecordsTab'
import MeetingRecordsTab from './components/MeetingRecordsTab'
// Paylaşılan form/satır-işlem sınıfları (admin-form, admin-field, admin-row-actions).
import '../admin/admin.css'
import './timePortfolio.css'

/**
 * **Zaman Portföyü Veri Girişi** (23.09.2026) — Genel Müdür'ün zamanının nereye gittiğini besleyen iki
 * kayıt kümesi, iki sekmede: **Toplantı Kaydı** (`GM_MEETING_RECORD`) ve **Uçuş Kaydı**
 * (`GM_FLIGHT_RECORD`). Başlık = menü adı (anayasa kuralı).
 *
 * <p>Yetki tek koddur (`TIME_PORTFOLIO_MANAGE`, roller 1/3/4/8): ekran tek bir veri giriş yüzeyidir,
 * sekmeler aynı işin iki kaydıdır. Rota kilidi menüden türer; uçlar ayrıca sınıf düzeyinde korunur.
 *
 * <p><b>Sekme gövdeleri ayrı bileşenlerdir</b> ve `TabView` seçilmeyen paneli çizmediği için pasif
 * sekmenin sorgusu hiç çalışmaz — iki liste isteği aynı anda gitmez. Sekme durumu (sayfa, süzgeç)
 * bilinçli olarak her sekmenin kendindedir: ikisi farklı alan kümeleriyle süzülüyor, ortak bir durum
 * yalnız birbirini sıfırlardı.
 */
export default function TimePortfolioPage() {
  const { t } = useTranslation()
  const [tabIndex, setTabIndex] = useState(0)

  return (
    <div className="admin-page">
      <ConfirmDialog />
      <PageHeader title={t('nav.timePortfolio.entry')} />

      <TabView activeIndex={tabIndex} onTabChange={(e) => setTabIndex(e.index)}>
        <TabPanel header={t('timePortfolio.tab.meeting')}>
          <MeetingRecordsTab />
        </TabPanel>
        <TabPanel header={t('timePortfolio.tab.flight')}>
          <FlightRecordsTab />
        </TabPanel>
      </TabView>
    </div>
  )
}
